import React, { useEffect, useRef, useState } from 'react'
import { Textfit } from 'react-textfit'
import { Checkdevice, Invdate, Timelineobj } from '../../../../../../../../../components'
import { g_fs, FS_LH_MAP, HUMANSIM_ICON, INVITESOCIALMEDIASIM_ARR, ILOOKUPTEMPLATESINFO_MAP } from '../../../../../../../../../config/constants'
import { title_0, title_1, title_2 } from '../../../../../constants'
import { iconwrapper } from '../../../../../../../../../config/commonfunctions'
import { GALLERY_ICON, ITINERARY_ICON, RSVP_ICON, SEATINGS_ICON, RSVPTELEPHONE_ICON, GUESTBOOK_ICON, SMALLERMORE_ICON, SOCIALMEDIA_ICON, PROMOTE_ICON, REGISTRY_ICON, ARROWDOWN_ICON, PLAY_ICON, PAUSE_ICON, EXPAND_ICON } from '../../../../../../../../../config/svgicons'
import Jfmap from '../../../../../../../../../components/Jfmap/Jfmap'
import T1border from '../T1border/T1border'
import Runsvg from '../../../../../../../../../components/Runsvg/Runsvg'
import { allimages } from '../../../../../../../../../assets/invitationcard/index1'
import { S3CLOUD_CLOUDFRONT, S3CLOUD_CLOUDFRONT_ASSET } from '../../../../../../../../../config/s3directories'
import './T1sim.css'

const DEFAULTPARTYPROFILEIMG_MALE = 'invitation/party/m1.png'
const DEFAULTPARTYPROFILEIMG_FEMALE = 'invitation/party/f1.png'

const INFINITELOOP_MODE = 2
const EMPTY_SVG = 0

const maintext_fs = g_fs
const location_fs = g_fs
const schedule_fs = g_fs
const map_fs = g_fs
const qn_fs = g_fs
const howwemet_fs = maintext_fs
const proposal_fs = maintext_fs

function useLongPress() {
    return function (callback) {
        let timeout;
        let preventClick = false;

        function start() {
            timeout = setInterval(() => {
                preventClick = true;
                callback();
            }, 100);
        }

        function clear() {
            // Get a reference to the last interval + 1
            const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

            // Clear any timeout/interval up to that id
            for (let i = 1; i < interval_id; i++) {
                window.clearInterval(i);
            }

            timeout && clearInterval(timeout);
            preventClick = false;
        }

        function clickCaptureHandler(e) {
            if (preventClick) {
                e.stopPropagation();
                preventClick = false;
            }
        }

        return {
            onMouseDown: start,
            onTouchStart: start,
            onMouseUp: clear,
            onMouseLeave: clear,
            onTouchMove: clear,
            onTouchEnd: clear,
            onClickCapture: clickCaptureHandler
        };
    }
}

const iframedom = {
    width: "",
    height: "",
    src: "",
    frameBorder: "",
    allow: "",
}

function T1Single_WEB({ imgcss_map, heroimgs, aspectratio }) {
    const { boxShadow = false, borderRadius = false } = imgcss_map
    return <img
        className='T1SIM_img'
        style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            justifySelf: 'center',
            overflow: 'hidden',
            objectFit: 'cover',
            boxShadow: boxShadow ? 'rgb(121 121 121 / 50%) 0px 19px 38px, rgb(0 0 0 / 22%) 1px 5px 12px' : '',
            borderRadius: borderRadius ? 10 : 0,
        }}
        alt={''}
        src={(heroimgs && heroimgs[0])
            ? heroimgs[0]
            : null}
    />
}

function T1Marquee_WEB(props) {

    const { imgcss_map, wt, ht } = props
    const { boxShadow = false, borderRadius = false } = imgcss_map

    const [adjustedspeed, setAdjustedspeed] = useState(-1)
    const [totalcontentwidth, setTotalcontentwidth] = useState(-1)
    const [heroimgs, setHeroimgs] = useState([])
    const styleElRef = useRef(null);
    const marqueeRef = useRef(null);

    useEffect(() => {
        if (!props.heroimgs || props.heroimgs.length === 0) return;
        setTotalcontentwidth(wt * props.heroimgs.length)
        setAdjustedspeed(((wt * props.heroimgs.length) / 500) * 2);
        setHeroimgs(props.heroimgs);

    }, [props.heroimgs, wt]);

    useEffect(() => {
        if (!totalcontentwidth || totalcontentwidth <= 0) return;

        const styleId = 't1-marquee-keyframes-style';

        // Check if a style with this ID already exists
        let styleEl = document.getElementById(styleId);

        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = styleId;
            document.head.appendChild(styleEl);
        }

        styleEl.innerHTML = `
          @keyframes marquee {
            from { transform: translateX(0); }
            to { transform: translateX(-${totalcontentwidth}px); }
          }
        `;

        styleElRef.current = styleEl;

        // Cleanup only if this component added it
        return () => {
            const existing = document.getElementById(styleId);
            if (existing) {
                document.head.removeChild(existing);
            }
            styleElRef.current = null;
        };
    }, [totalcontentwidth]);

    return (
        <div
            className='T1sim_marquee_web'
            style={{
                display: 'block',
                justifySelf: 'center',
                overflow: "hidden",
                whiteSpace: "nowrap",
                aspectRatio: 4 / 5,
                height: 'auto',
                boxShadow: boxShadow ? 'rgb(121 121 121 / 50%) 0px 19px 38px, rgb(0 0 0 / 22%) 1px 5px 12px' : '',
                borderRadius: borderRadius ? 10 : 0, overflow: 'hidden',
            }}>
            <div
                ref={marqueeRef}
                style={{
                    minWidth: wt,
                    display: "flex",
                    animation: `${adjustedspeed}s linear infinite marquee`,  // Use adjustedSpeed here
                    willChange: "transform", // added for smoother animation
                    height: '100%',
                }}
            >
                {[...heroimgs, ...heroimgs].map((img, index) => (
                    <img
                        key={index + img}
                        src={img}
                        style={{
                            aspectRatio: 4 / 5,
                            display: 'flex',
                            objectFit: 'cover',
                            height: '100%',
                            maxWidth: wt,
                            minWidth: wt,
                        }}
                    />
                ))}
            </div>

        </div>
    );
}

function T1Slideshow_WEB({ imgcss_map, heroimgs, wt, aspectratio }) {
    const { boxShadow = false, borderRadius = false } = imgcss_map
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeIndex, setFadeIndex] = useState(0);
    const [fade, setFade] = useState(true);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setFade(false); // Start fade-out effect
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % heroimgs.length);
                setFade(true); // Start fade-in effect after image change
                setTimeout(() => {
                    setFadeIndex((prevIndex) => (prevIndex + 1) % heroimgs.length);
                }, 500); // Delay fadeIndex update for smoother transition
            }, 1000); // Extended fade time for a smoother effect
        }, 4000); // Increased time between transitions for smooth effect

        return () => clearInterval(intervalId);
    }, [heroimgs.length]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'auto',
            overflow: 'hidden',
            position: 'relative',
            width: wt,
            aspectRatio: aspectratio.toString(),
            borderRadius: borderRadius ? 10 : 0,
            boxShadow: boxShadow ? 'rgb(121 121 121 / 50%) 0px 19px 38px, rgb(0 0 0 / 22%) 1px 5px 12px' : '',
        }}>
            <img
                key={currentIndex}
                src={heroimgs[currentIndex]}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'slideshowopacity 12s infinite',
                    aspectRatio: aspectratio.toString(),
                }}
            />

            <style>
                {`
                    @keyframes slideshowopacity {
                        0% {
                            opacity: 1;
                          }
                          33.3333% {
                            opacity: 1;
                          }
                          50% {
                            opacity: 0;
                          }
                          83.3333% {
                            opacity: 0;
                          }
                          100% {
                            opacity: 1;
                          }
                    }
                `}
            </style>

        </div>
    );
}

function T1sim(props) {

    const {
        btmbarff, css_map, countdown, date_e, date_w, datetimeff, displayonoffmap,
        displayseq, displaytxtmap, dt_type, fc, heroimgs, heroimglayout, ht,
        images, itype, lat, location, location_map, locationff,
        locurl, long, maintext, mapmode, menuicongate, menutype, name, ntw,
        party, partyproperties, prebuildtemplatedesign_map, priff, promote,
        qnas, rsvpactive, schedules, secff, socialmedias, spousename,
        styleborder, stylebordercolor, styleborderbr, styleborderwt,
        styleformation, styleorientation, stylesep, styletype,
        templateattr_map, templatetype, textures, time,
        whowwemet, wproposal, wt, menuattr_map, heroimgattr_map,
        // svgoverlay_map,imgcss_map, 
    } = props

    // const {
    //     borderRadius = false,
    //     boxShadow = false,
    //     webimgconstant = 1, tabletimgconstant = 1, mobileimgconstant = 1 } = imgcss_map // only exist in mobile

    const [prerenderdone, setPrerenderdone] = useState(false)
    const [menustyle, setMenustyle] = useState({})
    const [startrunsvg, setStartrunsvg] = useState(false)
    const [svgstate, setSvgstate] = useState('PLAYING') // PLAYING, PAUSE
    const [mapiframe, setMapiframe] = useState(iframedom)
    const [imgcss_map, setImgcss_map] = useState({
        borderRadius: false,
        boxShadow: false,
        webimgconstant: 1,
        tabletimgconstant: 1,
        mobileimgconstant: 1
    })
    const [svgoverlay_map, setSvgoverlay_map] = useState({})
    const device = Checkdevice();
    const scrollcontainerref = useRef(null)
    const onLongPress = useLongPress();

    useEffect(() => {
        setStartrunsvg(true)
    }, [])

    useEffect(() => {
        const { location_map } = props
        if (location_map && location_map['googleiframesrc'] && location_map['googleiframesrc'].length > 0) {
            const { googleiframesrc } = location_map

            const parseIframeAttributes = (iframeString) => {
                // Use a DOMParser to parse the iframe string
                const parser = new DOMParser();
                const doc = parser.parseFromString(iframeString, "text/html");
                const iframeElement = doc.querySelector("iframe");

                // Extract attributes from the iframe element and convert them to an object
                const attributes = {};
                Array.from(iframeElement.attributes).forEach((attr) => { attributes[attr.name] = attr.value; });

                return { width: '100%', height: 150, src: attributes.src, frameBorder: '' };
            };

            const local_googleiframesrc = parseIframeAttributes(googleiframesrc)
            setMapiframe(local_googleiframesrc)

        }
    }, [props])

    useEffect(() => {
        setPrerenderdone(false)
    }, [secff])

    useEffect(() => {
        setMenustyle(menuattr_map[templatetype])
        setImgcss_map(heroimgattr_map[templatetype]['css_map'])
        setSvgoverlay_map(heroimgattr_map[templatetype]['svgoverlay_map'])
    }, [props])

    function scrollup() {
        scrollcontainerref.current.scrollTop = scrollcontainerref.current.scrollTop > 1
            ? scrollcontainerref.current.scrollTop - 10
            : 0
    }

    function scrolldown() {
        scrollcontainerref.current.scrollTop = scrollcontainerref.current.scrollTop + 10;
    }

    const Topbar = <div className='T1sim_topbar' style={{ width: wt }}>
        <div className='T1sim_topbarcircle T1sim_1circle' />
        <div className='T1sim_topbarcircle T1sim_2circle' />
        <div className='T1sim_topbarcircle T1sim_3circle' />
    </div>

    const sep_dom = stylesep && stylesep.length > 0
        ? stylesep === ''
            ? <div style={{ border: 'none', width: '100%', height: 20, marginTop: 20, color: props.fc, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} />
            : <div style={{ width: '100%', height: 20, marginTop: 20, color: props.fc, alignSelf: 'center', backgroundImage: 'url(' + stylesep + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} />
        : null

    const prerendertitle_dom = <Textfit
        key={"prerender_title_dom"}
        className={"prerender_title_dom"}
        onReady={() => { setTimeout(() => setPrerenderdone(true), 100) }}
        style={{ height: title_1.websimulator_ht, width: wt * 0.52, color: 'transparent', margin: 10, display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: 'normal', alignItems: 'center', position: 'absolute' }}>
        Prerender_Prerender_Prerender
    </Textfit>

    const titleroot_ht = { // actual device
        'WEB': [
            title_0.websimulator_ht,
            title_1.websimulator_ht,
            title_2.websimulator_ht,
        ],
        'TABLET': [
            title_0.tabletsimulator_ht,
            title_1.tabletsimulator_ht,
            title_2.tabletsimulator_ht,
        ],
        'MOBILE': [
            title_0.mobilesimulator_ht,
            title_1.mobilesimulator_ht,
            title_2.mobilesimulator_ht,
        ]
    }[device][ntw]

    const containermargin = 15

    const title_dom = prerenderdone
        ? [
            <Textfit key={"w" + ntw + wt} style={{ height: titleroot_ht, width: wt * 0.55, fontFamily: secff, color: fc, margin: containermargin, display: 'flex', flexDirection: 'column', placeContent: 'center', fontWeight: 'normal', position: 'relative' }}>
                <div style={{ height: titleroot_ht * title_0.title_layer1, width: wt * 0.55, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end' }}>{name}</div>
                <Textfit style={{ height: titleroot_ht * title_0.title_layer2, width: wt * 0.55, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'baseline' }}>{'&'}</Textfit>
                <div style={{ height: titleroot_ht * title_0.title_layer3, width: wt * 0.55, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>{spousename}</div>
            </Textfit>,
            <Textfit key={"w" + ntw + wt} style={{ height: titleroot_ht, width: wt * 0.52, fontFamily: secff, color: fc, margin: containermargin, display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: 'normal', alignItems: 'center' }}>
                <div style={{ height: titleroot_ht * title_1.title_layer1, width: wt * 0.52, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end' }}>{name}</div>
                <div style={{ height: titleroot_ht * title_1.title_layer2, width: wt * 0.52, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>{"& " + spousename}</div>
            </Textfit>,
            <Textfit key={"w" + ntw + wt} style={{ height: titleroot_ht, width: wt * 0.55, fontFamily: secff, color: fc, padding: containermargin, placeContent: 'center', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
                {name + ' & ' + spousename}
            </Textfit>][ntw]
        : <div style={{ fontSize: 12, margin: 10, height: titleroot_ht }}></div>

    const mainimg_dom = <div style={{ width: `calc( 60% * ${imgcss_map.webimgconstant} )`, height: 'auto', zIndex: 999, position: 'relative', display: 'flex', marginBottom: 25 }}>

        <div style={{ height: 'calc( 100% - 40px )', width: '100%', position: 'absolute', display: 'flex', margin: '20px 0px', zIndex: 1 }}>
            <Runsvg startrunsvg={startrunsvg} svgoverlay_map={svgoverlay_map} svgstate={svgstate} device={'WEB'} />
        </div>

        {(svgoverlay_map && svgoverlay_map && svgoverlay_map['replay'] && svgoverlay_map['mode'] === INFINITELOOP_MODE && svgoverlay_map['svgitem'] !== EMPTY_SVG)
            ? <button
                onClick={() => {
                    setSvgstate(svgstate === 'PAUSE' ? 'PLAYING' : 'PAUSE')
                }}
                style={{ color: svgoverlay_map['color'], border: 'none', bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', placeContent: 'center', padding: 0, margin: 5, backgroundColor: 'transparent', zIndex: 1 }}
            >
                {{
                    'PAUSE': iconwrapper(PLAY_ICON, { width: 15, height: 15, display: 'flex' }),
                    'PLAYING': iconwrapper(PAUSE_ICON, { width: 15, height: 15, display: 'flex' })
                }[svgstate]}
            </button>
            : null}

        {{
            'single': <T1Single_WEB // DONE
                imgcss_map={imgcss_map}
                heroimgs={heroimgs}
                aspectratio={ILOOKUPTEMPLATESINFO_MAP[templatetype]['marquee']['img_edit']['aspectratio']}
            />,
            'marquee': <T1Marquee_WEB // DONE
                imgcss_map={imgcss_map}
                heroimgs={heroimgs}
                wt={wt * 0.6 * { 'WEB': imgcss_map.webimgconstant, 'TABLET': imgcss_map.tabletimgconstant, 'MOBILE': imgcss_map.mobileimgconstant }[device]}
                ht={ht}
                aspectratio={ILOOKUPTEMPLATESINFO_MAP[templatetype]['marquee']['img_edit']['aspectratio']}
            />,
            'slideshow': <T1Slideshow_WEB // DONE
                imgcss_map={imgcss_map}
                heroimgs={heroimgs}
                wt={wt * 0.6 * { 'WEB': imgcss_map.webimgconstant, 'TABLET': imgcss_map.tabletimgconstant, 'MOBILE': imgcss_map.mobileimgconstant }[device]}
                aspectratio={ILOOKUPTEMPLATESINFO_MAP[templatetype]['marquee']['img_edit']['aspectratio']}
            />
        }[heroimglayout]}

    </div>

    const maintext_dom = (maintext && maintext.length > 0)
        // ? <div key={'mt'} style={{ fontSize: maintext_fs, lineheight: FS_LH_MAP[maintext_fs], color: fc, width: '60%', display: 'flex', justifyContent: 'center', alignSelf: 'center', padding: '35px 15px 15px 15px', flexDirection: 'column', ...css_map['maintext'], }}>{maintext}</div>
        ? <div key={'mt'} style={{ fontSize: maintext_fs, lineheight: FS_LH_MAP[maintext_fs], color: fc, width: '60%', display: 'flex', justifyContent: 'center', alignSelf: 'center', padding: '15px 25px', flexDirection: 'column', ...css_map['maintext'], }}>{maintext}</div>
        : null

    const location_dom = location ?
        <div
            key={'loc'}
            style={{ fontSize: location_fs * 2.0625, color: fc, fontFamily: locationff, cursor: 'pointer', fontWeight: 'bold', zIndex: 999, display: 'flex', justifyContent: 'center', textAlign: 'center', padding: 15, flexDirection: 'row', whiteSpace: 'pre' }}
        // onClick={() => { if (lat.length > 0 && long.length > 0) window.open("https://www.google.com/maps/search/?api=1&query=" + lat + "," + long, "_blank") }}
        >
            {location}
        </div>
        : null

    const datetime_dom = React.cloneElement(
        <Invdate
            countdown={countdown}
            date_e={date_e}
            date_w={date_w}
            itype={itype}
            dt_type={dt_type}
            time={time}
            fc={fc}
            bgcolor={
                (
                    templatetype &&
                    templateattr_map &&
                    templateattr_map[templatetype] &&
                    templateattr_map[templatetype]['templatecolor']
                )
                    ? templateattr_map[templatetype]['templatecolor']
                    : ''
            }
            from={'T1sim'}
            datetimeff={datetimeff}
        />,
        { key: 'datedom' }
    )

    const howwemet_dom = () => {
        const lh = FS_LH_MAP[howwemet_fs]
        const dt = (whowwemet && whowwemet.length === 2) ? whowwemet[0] : ''
        const txt = (whowwemet && whowwemet.length === 2) ? whowwemet[1] : ''
        // return  dt.length > 0 || txt.length > 0
        return displayonoffmap['howwemet']
            ? <div key={'howwemet'} style={{ width: '60%', fontSize: howwemet_fs, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0px 25px 10px 25px' }}>
                {sep_dom}
                <div style={{ fontSize: howwemet_fs * 1.75, lineHeight: lh, fontFamily: secff, fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['howwemet']}
                </div>
                <div>{dt}</div>
                <div style={{ lineHeight: lh, ...css_map['howwemet'] }}>{txt}</div>
            </div>
            : null
    }

    const proposal_dom = () => {
        const dt = (wproposal && wproposal.length === 2) ? wproposal[0] : ''
        const txt = (wproposal && wproposal.length === 2) ? wproposal[1] : ''
        // return dt.length > 0 || txt.length > 0
        return displayonoffmap['proposal']
            ? <div key='proposal' style={{ width: '60%', fontSize: proposal_fs, color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0px 25px 10px 25px' }}>
                {sep_dom}
                <div style={{ fontSize: proposal_fs * 1.75, fontFamily: secff, fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['proposal']}
                </div>
                <div>{dt}</div>
                <div style={{ lineHeight: FS_LH_MAP[proposal_fs], ...css_map['proposal'] }}>{txt}</div>
            </div>
            : null
    }

    const qns_dom = displayonoffmap['qna']
        ? <div key='qns' style={{ width: '60%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            {sep_dom}
            <div style={{ fontFamily: secff, fontSize: qn_fs * 1.75, lineHeight: FS_LH_MAP[qn_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                {displaytxtmap['qna']}
            </div>
            {qnas && qnas.map((qna, i) => {
                if (i % 2 === 0) {
                    return <div key={'qnas_doms' + i} style={{ color: fc, display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'center', flexWrap: 'wrap', padding: i === 0 ? '0px 25px 10px 25px' : '10px 25px' }}>
                        <div style={{ fontSize: qn_fs, fontWeight: 'bold', lineHeight: FS_LH_MAP[qn_fs] }}>{qnas[i]}</div>
                        <div style={{ fontSize: qn_fs, lineHeight: FS_LH_MAP[qn_fs], }}>{qnas[i + 1]}</div>
                    </div>
                }
                else {
                    return null
                }
            })}
        </div>
        : null

    // const schedule_dom = schedules && schedules.length > 0
    const schedule_dom = displayonoffmap['schedule']
        ? <div key='schedule' style={{ width: '60%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            {sep_dom}
            <div style={{ fontSize: schedule_fs * 1.75, fontFamily: secff, lineHeight: FS_LH_MAP[schedule_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                {displaytxtmap['schedule']}
            </div>
            {schedules.map((item, index) => {
                return (
                    <Timelineobj
                        from="Invitationsimulator"
                        key={'timeline' + index}
                        index={index}
                        bb={index !== schedules.length - 1 ? `1px solid ${fc}4d` : 'none'} // borderBottom
                        date_s={item[0]}
                        date_e={item[1]}
                        time_s={item[2]}
                        time_e={item[3]}
                        name={item[4]}
                        whocanview={item[6]}
                        content={item[5]}
                        mapobj={item[8]}
                        itineraryobj={item[9]}
                        pri_fs={schedule_fs}
                        sec_fs={schedule_fs}
                        wt={'100%'}
                        dttimebox_wt={'max-content'}
                        content_ht={'max-content'}
                        fc={fc}
                        // bgc={templatecolor}
                        bgc={templateattr_map[templatetype]['templatecolor']}
                        mapmode={mapmode}
                        expandbtn={true}
                    />
                )
            })}
        </div>
        : null

    const map_dom = {
        'GOOGLE': (displayonoffmap['map'] && mapiframe && Object.keys(mapiframe) && mapiframe['src'] && mapiframe['src'].length > 0)
            ? <div key='map' style={{ width: '60%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: 20, alignItems: 'center' }}>
                {sep_dom}
                <div style={{ fontSize: map_fs * 1.75, fontFamily: secff, lineHeight: FS_LH_MAP[map_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['map']}
                </div>
                <iframe style={{ width: 'calc( 100% - 40px )', border: 'none' }}{...mapiframe}></iframe>
                <div style={{ fontSize: map_fs, padding: '10px 25px', display: 'flex', whiteSpace: 'pre-wrap', textAlign: props.css_map['locdescript'].textAlign }}>
                    {props.location_map['locdescript']}
                </div>
            </div>
            : null,
        'LEAFLET': displayonoffmap['map']
            ? <div key='map' style={{ width: '60%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: 20, alignItems: 'center' }}>
                {sep_dom}
                <div style={{ fontSize: map_fs * 1.75, fontFamily: secff, lineHeight: FS_LH_MAP[map_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['map']}
                </div>
                <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <a
                        style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', position: 'absolute', zIndex: 999, right: 0, backgroundColor: 'transparent', borderRadius: 5, cursor: 'pointer', margin: '5px 25px 0px 0px' }}
                        href={props.location_map['leafletlocurl']}
                        target='_blank'
                    >
                        {iconwrapper(EXPAND_ICON, { transform: 'scale(0.75)', width: 21, height: 21, display: 'flex', borderRadius: 4, padding: 5, placeContent: 'center', alignItems: 'center', backgroundColor: 'white', boxShadow: 'rgba(0, 0, 0, 0.65) 0px 1px 5px', color: 'var(--maindark)' })}
                    </a>
                    <Jfmap
                        key={'latlong' + props.location_map['leafletlat'] + props.location_map['leafletlong']}
                        markersData={[{ latLng: { lat: props.location_map['leafletlat'], lng: props.location_map['leafletlong'] } }]}
                        type={'small'}
                        smallstyle={{ height: 150, width: 'calc( 100% - 40px )', margin: '0px 20px' }}
                        zc={false}
                        gpsiconsize={[12, 20]}
                        mapmode={props.location_map['leafletmapmode']}
                    />
                    <div style={{ fontSize: map_fs, padding: '10px 25px', display: 'flex', whiteSpace: 'pre-wrap', textAlign: props.css_map['locdescript'].textAlign }}>
                        {props.location_map['locdescript']}
                    </div>
                </div>
            </div>
            : null
    }[location_map['maptype']]

    const party_dom = displayonoffmap['party']
        ? [
            <div key='party' style={{ width: '60%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                {sep_dom}
                <div style={{ fontFamily: secff, fontSize: qn_fs * 1.75, lineHeight: FS_LH_MAP[qn_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['party']}
                </div>
                {party.map((item, index) => {
                    if ((index + 1) % 2 === 0) return
                    const firstitem = party[index]
                    const seconditem = ((index + 1) < party.length) ? party[index + 1] : null
                    const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                    const imgdim = 80
                    const contentht = 150
                    const smallfs = 7
                    const lgfs = 9
                    const imgmarginbtm = 3

                    console.log('firstitem.photo', firstitem.photo)
                    const firstitemimg = (firstitem.photo === DEFAULTPARTYPROFILEIMG_MALE || firstitem.photo === DEFAULTPARTYPROFILEIMG_FEMALE)
                        ? (S3CLOUD_CLOUDFRONT_ASSET + firstitem.photo)
                        : S3CLOUD_CLOUDFRONT + firstitem.photo

                    if (seconditem) {

                        const seconditemimg = (seconditem.photo === DEFAULTPARTYPROFILEIMG_MALE || seconditem.photo === DEFAULTPARTYPROFILEIMG_FEMALE)
                            ? (S3CLOUD_CLOUDFRONT_ASSET + seconditem.photo)
                            : S3CLOUD_CLOUDFRONT + seconditem.photo

                        return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', padding: '0px 25px 30px 25px' }}>
                            <div id={firstitem.id} style={{ width: '50%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                <img
                                    src={firstitemimg}
                                    style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginbottom: imgmarginbtm }}
                                />
                                <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                    <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                    <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                                    <div style={{ fontSize: lgfs, textAlign: 'center', padding: '5px 10px' }}>{firstitem.info}</div>
                                </div>
                            </div>
                            <div id={seconditem.id} style={{ width: '50%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                <img src={seconditemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginbottom: imgmarginbtm }} />
                                <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                    <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{seconditem.name}</div>
                                    <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{seconditem.title}</div>
                                    <div style={{ fontSize: lgfs, textAlign: 'center', padding: '5px 10px' }}>{seconditem.info}</div>
                                </div>
                            </div>
                        </div>
                    }
                    else {
                        return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', padding: '0px 25px 30px 25px' }}>
                            <div id={firstitem.id} style={{ width: '50%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                <img src={firstitemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginbottom: imgmarginbtm }} />
                                <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                                <div style={{ fontSize: lgfs, textAlign: 'center', padding: '5px 10px' }}>{firstitem.info}</div>
                            </div>
                        </div>
                    }
                })}
            </div>,
            <div key='party' style={{ width: '60%', color: fc, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                {sep_dom}
                <div style={{ fontFamily: secff, fontSize: qn_fs * 1.75, lineHeight: FS_LH_MAP[qn_fs], fontWeight: 'bold', display: 'flex', justifyContent: 'center', margin: 10, padding: '0px 5px', borderRadius: 5, alignSelf: 'center' }}>
                    {displaytxtmap['party']}
                </div>
                {party.map((item, index) => {
                    if ((index + 1) % 2 === 0) return
                    const firstitem = party[index]
                    const seconditem = ((index + 1) < party.length) ? party[index + 1] : null
                    const imgbr = (partyproperties && partyproperties['imageshape'] ? '100%' : 5)
                    const imgdim = 80
                    const contentht = 90
                    const smallfs = 7
                    const lgfs = 9

                    const firstitemimg = (firstitem.photo === DEFAULTPARTYPROFILEIMG_MALE || firstitem.photo === DEFAULTPARTYPROFILEIMG_FEMALE)
                        ? (S3CLOUD_CLOUDFRONT_ASSET + firstitem.photo)
                        : S3CLOUD_CLOUDFRONT + firstitem.photo

                    if (seconditem) {

                        const seconditemimg = (seconditem.photo === DEFAULTPARTYPROFILEIMG_MALE || seconditem.photo === DEFAULTPARTYPROFILEIMG_FEMALE)
                            ? (S3CLOUD_CLOUDFRONT_ASSET + seconditem.photo)
                            : S3CLOUD_CLOUDFRONT + seconditem.photo
                        return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', padding: '0px 25px 30px 25px' }}>
                            <div id={firstitem.id} style={{ width: '50%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                <img src={firstitemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginbottom: 3 }} />
                                <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                    <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                    <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                                </div>
                            </div>
                            <div id={seconditem.id} style={{ width: '50%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                <img src={seconditemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginbottom: 3 }} />
                                <div style={{ marginTop: 10, display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
                                    <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{seconditem.name}</div>
                                    <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{seconditem.title}</div>
                                </div>
                            </div>
                        </div>
                    }
                    else {
                        return <div key={'party' + index} style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', padding: '0px 25px 30px 25px' }}>
                            <div id={firstitem.id} style={{ width: '50%', minHeight: contentht, display: 'flex', placeItems: 'center', flexDirection: 'column' }}>
                                <img src={firstitemimg} style={{ borderRadius: imgbr, minWidth: imgdim, minHeight: imgdim, maxWidth: imgdim, maxHeight: imgdim, marginbottom: 3 }} />
                                <div style={{ fontSize: lgfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center' }}>{firstitem.name}</div>
                                <div style={{ fontSize: smallfs, display: 'flex', whiteSpace: 'pre', placeContent: 'center', marginTop: 5 }}>{firstitem.title}</div>
                            </div>
                        </div>
                    }
                })}
            </div>
        ][partyproperties['format']]
        : null

    const rsvp_dom = rsvpactive
        ? <button key='rsvp' style={{
            width: 'calc( 60% - 40px )', height: '30px', color: fc, fontFamily: secff, margin: '15px 20px', border: `1px solid ${fc}`, borderRadius: 5,
            backgroundColor: templateattr_map[templatetype]['templatecolor'],
            // backgroundColor: templatecolor,
        }}>
            RSVP
        </button>
        : null

    const bg = () => {
        const { background, bgformat = [] } = allimages.get(styletype)['t1']
        let curr_bgformat = bgformat[styleformation]
        let curr_orientation = curr_bgformat['orientation_allow_list'][parseInt(styleorientation)]

        let firstimg_orientation = curr_orientation['img1']
        let secondimg_orientation = curr_orientation['img2']

        let firstimg_positionincard = curr_bgformat['WEB_TABLET']['bg1']
        let secondimg_positionincard = curr_bgformat['WEB_TABLET']['bg2']

        // 'lookup' is replace to 'edit', so to use smaller image size
        let image1_url = firstimg_positionincard ? 'url(' + background[firstimg_positionincard]['url'][firstimg_orientation].replace('lookup', 'edit') + ')' : null
        let image2_url = secondimg_positionincard ? 'url(' + background[secondimg_positionincard]['url'][secondimg_orientation].replace('lookup', 'edit') + ')' : null

        return [
            <div
                key={'tsim_a'}
                className={firstimg_positionincard + '_wt_simulator'}
                style={{ backgroundImage: image1_url, position: 'absolute', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', zIndex: 998, }}
            />,
            <div
                key={'tsim_b'}
                className={secondimg_positionincard + '_wt_simulator'}
                style={{ backgroundImage: image2_url, position: 'absolute', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', zIndex: 998, }}
            />
        ]

    }

    // inactive
    const socialmedia_dom = <div style={{ color: fc, display: 'flex', flexDirection: 'row', placeContent: 'center' }}>
        {socialmedias.map((media, i) => media.length > 0 ? <div key={'socialmedia' + i} style={{ padding: 3, margin: 3 }}>{INVITESOCIALMEDIASIM_ARR[i]}</div> : null)}
        {(promote && promote.length > 0) ? <div style={{ padding: 3, margin: 3, borderLeft: 'thin solid rgba(192, 192, 192, 0.37)' }}>{HUMANSIM_ICON}</div> : null}
    </div>

    const devicedim = 14
    const GENERALICON_CSS = { width: devicedim, height: devicedim, display: 'flex', margin: 4 }

    const LOGO_MAP = {
        'RSVP': iconwrapper(RSVP_ICON, GENERALICON_CSS),
        'Gallery': iconwrapper(GALLERY_ICON, GENERALICON_CSS),
        'Itinerary': iconwrapper(ITINERARY_ICON, GENERALICON_CSS),
        'Contact': iconwrapper(RSVPTELEPHONE_ICON, GENERALICON_CSS),
        'Seatings': iconwrapper(SEATINGS_ICON, GENERALICON_CSS),
        'Guestbook': iconwrapper(GUESTBOOK_ICON, GENERALICON_CSS),
        'More': iconwrapper(SMALLERMORE_ICON, GENERALICON_CSS),
        'Share': iconwrapper(SOCIALMEDIA_ICON, GENERALICON_CSS),
        'Promote': iconwrapper(PROMOTE_ICON, GENERALICON_CSS),
        'Registry': iconwrapper(REGISTRY_ICON, GENERALICON_CSS),
    }

    const borderfornav = `1px solid ${menustyle.borderColor}`

    // menutype: none, btmnavbar, stickytopnav, menu, btmnavbarwithouticon,
    const nav_dom = menutype === 'btmnavbar'
        ? <div className={menuicongate ? 'T1sim_btmnav' : 'T1sim_btmnav_withouticon'} style={{ width: 'calc( 60% - 10px )', fontFamily: btmbarff, backgroundColor: menustyle.backgroundColor, borderTop: borderfornav, borderLeft: borderfornav, borderRight: borderfornav, placeContent: 'center' }}>
            {props.menuseq.map((ms, index) => {
                if (ms === 'RSVP' && !rsvpactive) { return null }

                if (menuicongate) {
                    return <div
                        key={index + 'ms'}
                        className={'T1sim_btmnavitem'}
                        style={{ border: menustyle.borderColor, color: menustyle.color }}
                    >
                        {LOGO_MAP[ms]}
                        <div className='ilookup_btmtxt' style={{ fontSize: 6, height: 'max-content', padding: 0 }}>{ms}</div>
                    </div>

                }
                else {
                    return <div
                        key={index + 'ms'}
                        className={'T1sim_btmnavitem_withouticon'}
                        style={{ border: menustyle.borderColor, color: menustyle.color }}
                    >
                        <div className='ilookup_btmtxt' style={{ fontSize: 9, height: 'max-content', padding: '0px 2px' }}>{ms}</div>
                    </div>

                }
            })}
        </div>
        : menutype === 'stickytopnav' ?
            <div className='T1sim_topnav' style={{ fontFamily: btmbarff, backgroundColor: menustyle.backgroundColor, borderBottom: borderfornav, placeContent: 'center' }}>
                {props.menuseq.map((ms, index) => {
                    if (ms === 'RSVP' && !rsvpactive) {
                        return null
                    }
                    return <div
                        key={index + 'ms'}
                        className='T1sim_topnavitem'
                        style={{ border: menustyle.borderColor, color: menustyle.color }}
                    >
                        <div className='ilookup_toptxt' style={{ fontSize: 10, height: 'max-content' }}>{ms}</div>
                    </div>
                })}
            </div>
            : menutype === 'none'
                ? null
                : null


    const seq_dom = {
        'maintext': maintext_dom,
        'location': location_dom,
        'date': datetime_dom,
        'howwemet': howwemet_dom(),
        'proposal': proposal_dom(),
        'schedule': schedule_dom,
        'qna': qns_dom,
        'map': map_dom,
        'rsvp': rsvp_dom,
        'party': party_dom
    }

    // (templatetype === 1 && styletype === 'Empty') ||
    if ((templatetype === 2 && prebuildtemplatedesign_map && prebuildtemplatedesign_map[2] && prebuildtemplatedesign_map[2]['styletype'] === 'Empty')) {
        return <div>Select a pre-built template to get started.</div>
    }

    return <div id="T1sim_webulti">
        <div id='T1sim_webroot' style={{
            width: wt,
            height: ht,
            backgroundImage: `url(${textures[0]})`, fontFamily: priff,
            backgroundColor: templateattr_map[templatetype]['templatecolor']
            //  backgroundColor: templatecolor,
        }}
        >
            {Topbar}
            {bg()}
            <div
                ref={scrollcontainerref}
                className='T1sim_contentroot'
                style={{
                    paddingTop: menutype === 'stickytopnav' ? 30 : 0,
                    position: 'relative',
                    width: '100%', display: 'flex', overflow: 'hidden scroll', justifyContent: 'center', zIndex: 333
                }}
            >
                {/* <div ref={scrollcontainerref} className='T1sim_contentroot' style={{ width: '100%', display: 'flex', overflow: 'hidden', justifyContent: 'center', zIndex: 333 }}> */}
                <T1border styleborder={styleborder} simulatordevice={'WEB'} styleborderwt={styleborderwt} styleborderbr={styleborderbr} stylebordercolor={stylebordercolor} >
                    <div style={{ width: '100%', height: 'max-content', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 30, borderRadius: 5, overflowX: 'hidden', }}>
                        {prerendertitle_dom}
                        {title_dom}
                        {mainimg_dom}
                        {displayseq.map((seqkey) => seq_dom[seqkey])}
                        <div style={{ height: 55, width: 1 }} />
                        {/* 
                        {maintext_dom}
                        {location_dom}
                        {datetime_dom}
                        {howwemet_dom()}
                        {proposal_dom()}
                        {schedule_dom}
                        {qns_dom}
                        {map_dom}
                        {rsvp_dom}
                         */}
                    </div>
                </T1border>
                {nav_dom}
            </div>

        </div>

        {device === 'WEB'
            ? <div className='simulator_clickscrollroot'>
                <button className="simulator_mobileclickscroll simulator_noselect" onClick={scrollup} {...onLongPress(scrollup)} >
                    {iconwrapper(ARROWDOWN_ICON, { width: 25, height: 25, transform: 'rotate(180deg)' })}
                </button>
                <div style={{ margin: 2.5 }} />
                <button className="simulator_mobileclickscroll simulator_noselect" onClick={scrolldown} {...onLongPress(scrolldown)} >
                    {iconwrapper(ARROWDOWN_ICON, { width: 25, height: 25 })}
                </button>
            </div>
            : null}
    </div>
}

export default T1sim